import { render, staticRenderFns } from "./ProductUses.vue?vue&type=template&id=f82a1c68&scoped=true&lang=html&"
import script from "./ProductUses.vue?vue&type=script&lang=js&"
export * from "./ProductUses.vue?vue&type=script&lang=js&"
import style0 from "./ProductUses.vue?vue&type=style&index=0&id=f82a1c68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a1c68",
  null
  
)

export default component.exports